var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "content-list" },
    [
      _vm.title
        ? _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm.contents.length > 0
        ? [
            _c(
              "ul",
              { staticClass: "list-unstyled content" },
              _vm._l(_vm.contents, function (item, index) {
                return _c(
                  "b-media",
                  { key: index, attrs: { tag: "li", item: item } },
                  [
                    _c("b-img", {
                      attrs: {
                        slot: "aside",
                        "blank-color": "#abc",
                        width: "64",
                        alt: item.alt,
                      },
                      slot: "aside",
                    }),
                    _c("h5", { staticClass: "mt-0 mb-1" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _vm._v(_vm._s(item.desc)),
                  ],
                  1
                )
              }),
              1
            ),
            _vm.query && _vm.more
              ? _c(
                  "a",
                  {
                    staticClass: "loadmore",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.loadMore.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("more")]
                )
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "message empty-list" }, [
              _vm._v("nothing to show yet"),
            ]),
            _vm.query
              ? _c(
                  "a",
                  {
                    staticClass: "loadmore",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.loadMore.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("refresh")]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }